import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  AEMLink,
  AlreadyPurchasedSectionRouteMappingProps,
  NavigationRouteProps,
} from '@msc-b2c/interfaces/types';

export interface NavigationMenuState {
  navigationItems?: NavigationRouteProps[];
  allMyCruisesLink?: AEMLink;
  noLinkedBookingLink?: AEMLink;
  cartLink?: AEMLink;
  checkoutLink?: AEMLink;
  alreadyPurchasedLink?: AEMLink;
  alreadyPurchasedSectionRouteMapping?: AlreadyPurchasedSectionRouteMappingProps[];
}

const initialState: NavigationMenuState = {
  navigationItems: [],
  allMyCruisesLink: {},
  noLinkedBookingLink: {},
  cartLink: {},
  checkoutLink: {},
  alreadyPurchasedLink: {},
  alreadyPurchasedSectionRouteMapping: [],
};

const navigationMenuSlice = createSlice({
  name: 'navigationMenuData',
  initialState,
  reducers: {
    navigationCreated(state, action: PayloadAction<NavigationMenuState>) {
      state.navigationItems = action.payload.navigationItems;
      state.allMyCruisesLink = action.payload.allMyCruisesLink;
      state.noLinkedBookingLink = action.payload.noLinkedBookingLink;
      state.cartLink = action.payload.cartLink;
      state.checkoutLink = action.payload.checkoutLink;
      state.alreadyPurchasedLink = action.payload.alreadyPurchasedLink;
      state.alreadyPurchasedSectionRouteMapping =
        action.payload.alreadyPurchasedSectionRouteMapping;
    },
  },
});

export const { navigationCreated } = navigationMenuSlice.actions;
export default navigationMenuSlice.reducer;
